import { FC } from 'react';
import { Link, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ReactComponent as LinkIcon } from 'src/assets/svg/link.svg';
import { BRANDFOLDER_BASE_URL } from 'src/api/concierge';
import { getTheme } from 'src/utils/get-theme';

export const FaqRulesEngagementStrategy: FC = () => {
    const { t } = useTranslation();
    const { isHosTheme } = getTheme();

    return (
        <Stack gap="16px" marginTop="16px">
            <Link
                target="_blank"
                download
                href={
                    isHosTheme
                        ? `${BRANDFOLDER_BASE_URL}/2EZAWJN8/at/q4844b888v3p7qn4269vs8/HoS84_Resident_Engagement_Strategy_Doc.pdf`
                        : `${BRANDFOLDER_BASE_URL}/2EZAWJN8/at/7c8bmc3xcsnt4gcm2pb4rh4/VS2526_006_Resident_Engagement_Strategy_Updates_Resident_Engagement_Strategy___Welfare_Charter_V7.pdf`
                }
                display="flex"
                alignItems="center"
                gap="8px"
            >
                <Typography variant="subtitle2">
                    {t('faq_answer_resident_engagement_strategy_link_text')}
                </Typography>
                <LinkIcon />
            </Link>
        </Stack>
    );
};
